import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  GovernanceGroup,
  GovernanceGroupExtensionSchema,
  OrgExtensionSchema,
  OrgName,
  TeamMembership,
  TeamMembershipExtensionSchema,
  validateGovernanceGroup,
  validateTeamMembership,
} from './GovernanceGroupMembership';

export const GovernanceGroupFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    component: GovernanceGroup,
    name: 'GovernanceGroupField',
    validation: validateGovernanceGroup,
    schema: GovernanceGroupExtensionSchema,
  }),
);

export const OrgMembershipFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'OrgMembershipField',
    component: OrgName,
    schema: OrgExtensionSchema,
  }),
);

export const TeamMembershipFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    component: TeamMembership,
    name: 'TeamMembershipField',
    validation: validateTeamMembership,
    schema: TeamMembershipExtensionSchema,
  }),
);
